export default [
  {
    text: 'loyaltyPrograms.table.type',
    value: 'type',
  },
  {
    text: 'loyaltyPrograms.table.customerGroup',
    value: 'customerGroup',
  },
  {
    text: 'loyaltyPrograms.table.venue',
    value: 'venue',
  },
  {
    text: 'loyaltyPrograms.table.oauthId',
    value: 'oauthId',
  },
  {
    text: 'loyaltyPrograms.table.shopUuid',
    value: 'shopUuid',
  },
  {
    text: 'loyaltyPrograms.table.operator',
    value: 'operator',
  },
  {
    text: 'loyaltyPrograms.table.storeId',
    value: 'storeId',
  },
  {
    text: 'loyaltyPrograms.table.posType',
    value: 'posType',
  },
  {
    text: 'loyaltyPrograms.table.supportingPos',
    value: 'supportingPos',
  },
];
